var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9597 14.0503V15.742C8.9597 17.1753 7.62636 18.3336 5.98469 18.3336C4.34302 18.3336 3.00134 17.1753 3.00134 15.742V14.0503C3.00134 15.4836 4.33469 16.5003 5.98469 16.5003C7.62636 16.5003 8.9597 15.4753 8.9597 14.0503Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95834 11.7583C8.95834 12.175 8.84167 12.5583 8.64167 12.8916C8.15001 13.7 7.14166 14.2083 5.975 14.2083C4.80833 14.2083 3.79999 13.6916 3.30832 12.8916C3.10832 12.5583 2.9917 12.175 2.9917 11.7583C2.9917 11.0416 3.32501 10.4 3.85835 9.93331C4.40001 9.45831 5.14165 9.175 5.96665 9.175C6.79165 9.175 7.53335 9.46665 8.07501 9.93331C8.62501 10.3916 8.95834 11.0416 8.95834 11.7583Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9597 11.7583V14.05C8.9597 15.4833 7.62636 16.5 5.98469 16.5C4.34302 16.5 3.00134 15.475 3.00134 14.05V11.7583C3.00134 10.325 4.33469 9.16667 5.98469 9.16667C6.80969 9.16667 7.55138 9.45832 8.09305 9.92498C8.62638 10.3916 8.9597 11.0417 8.9597 11.7583Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 9.14164V10.8584C18.3333 11.3167 17.9667 11.6917 17.5 11.7083H15.8667C14.9667 11.7083 14.1417 11.05 14.0667 10.15C14.0167 9.62499 14.2167 9.13332 14.5667 8.79165C14.875 8.47498 15.3 8.29167 15.7667 8.29167H17.5C17.9667 8.30834 18.3333 8.6833 18.3333 9.14164Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 8.75001V7.08334C1.66663 4.81667 3.03329 3.23334 5.15829 2.96667C5.37496 2.93334 5.59996 2.91667 5.83329 2.91667H13.3333C13.55 2.91667 13.7583 2.92499 13.9583 2.95833C16.1083 3.20833 17.5 4.80001 17.5 7.08334V8.29168H15.7666C15.2999 8.29168 14.8749 8.475 14.5666 8.79166C14.2166 9.13333 14.0166 9.625 14.0666 10.15C14.1416 11.05 14.9666 11.7083 15.8666 11.7083H17.5V12.9167C17.5 15.4167 15.8333 17.0833 13.3333 17.0833H11.25",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletMoney);
export default __webpack_public_path__ + "static/media/wallet-money.64fccd59e062577f469348032fe3c6d1.svg";
export { ForwardRef as ReactComponent };